/**
 * Nass Closing Offer — cosmetic deal countdown.
 *
 * Purely visual urgency: reads a starting duration (seconds) from the
 * [data-nass-countdown] element's data-seconds, then ticks HH:MM:SS down
 * once a second, holding at 00:00:00. No real deadline is enforced — the
 * actual offer/price is controlled server-side. Respects a missing element
 * gracefully and never throws.
 */
(() => {
  const el = document.querySelector('[data-nass-countdown]');
  if (!el) return;

  const pad = (n) => String(n).padStart(2, '0');

  // Seconds until the next midnight in US Eastern (America/New_York, DST-aware).
  const secsUntilEasternMidnight = () => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).formatToParts(new Date());
    const val = (t) => parseInt(parts.find((p) => p.type === t)?.value || '0', 10);
    return 86400 - ((val('hour') % 24) * 3600 + val('minute') * 60 + val('second'));
  };

  // Daily HH:MM:SS countdown to 00:00 ET, resetting each day (data-seconds ignored).
  const render = () => {
    const r = secsUntilEasternMidnight();
    el.textContent = `${pad(Math.floor(r / 3600))}:${pad(Math.floor((r % 3600) / 60))}:${pad(r % 60)}`;
  };

  render();
  setInterval(render, 1000);
})();
